import { useEffect, useState } from 'react';
import { getProfile, updateProfile } from '../../../../entities/profile';
import { toast } from 'react-hot-toast';
import { LoaderCircle } from 'lucide-react';

export function ViewEditProfilePage() {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    phone_number: '',
    location: '',
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getProfile();
        const user = response;
        setForm({
          first_name: user.first_name || '',
          last_name: user.last_name || '',
          email_address: user.email_address || '',
          phone_number: user.phone_number || '',
          location: user.location || '',
        });
      } catch (error) {
        console.error('Error fetching profile', error);
        toast.error('Failed to load profile');
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateProfile(form);
      toast.success('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile', error);
      toast.error('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 w-full max-w-4xl mx-auto">
      <h2 className="text-2xl font-semibold mb-6">My Profile</h2>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FormField label="First Name" name="first_name" value={form.first_name} onChange={handleChange} required />
            <FormField label="Last Name" name="last_name" value={form.last_name} onChange={handleChange} />
          </div>

          {/* Email */}
          <FormField label="Email Address" name="email_address" value={form.email_address} disabled />

          {/* Phone + Location */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FormField label="Phone Number" name="phone_number" value={form.phone_number} onChange={handleChange} />
            <FormField label="Location" name="location" value={form.location} onChange={handleChange} />
          </div>

          {/* Save */}
          <div className="pt-4">
            <button type="submit" disabled={loading} className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition flex items-center justify-center gap-2 disabled:opacity-50">
              {loading && <LoaderCircle className="w-4 h-4 animate-spin" />}
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// 🔁 Reusable Input Field for Light Theme
function FormField({ label, name, value, onChange, disabled = false, required = false }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input type="text" name={name} value={value} onChange={onChange} disabled={disabled} required={required} className={`w-full px-3 py-2 rounded-lg border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''}`} />
    </div>
  );
}
